import React, { useEffect, useState } from "react";
import { flushSync } from "react-dom";
import { LoadingSpinnerBlock } from "../../components/LoadingSpinner";
import Header from "../../Header";
import SideMenu from "../../SideMenu";
import Footer from "../../Footer";
import api from "../../services/api";
import DataTable from "react-data-table-component";
import * as xlsx from 'xlsx-js-style';

import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Title,
  BarElement,
  LinearScale,
  CategoryScale,
  Legend,
} from "chart.js";
import { Doughnut } from "react-chartjs-2";

ChartJS.register(
  ArcElement,
  Tooltip,
  CategoryScale,
  LinearScale,
  BarElement,
  Legend,
  Title
);

export default function Painel({ history }) {
  const CustomAvaliacao = ({ row }) => row.tentativas + " tentativa(s)";

  const CustomCertificado = ({ row }) =>
  row?.linkCertificado ? (
    <a href={row.linkCertificado} target="_blank">Acessar Certificado</a>
  ) : (
    ""
  );

  const CustomStatus = ({ row }) =>
  row.status == 1 ? 
  ( <span className="label label-success"><a href="#" style={{color:'#fff'}}>Finalizado</a></span> ) : 
  ( <span className="label label-danger">Pendente</span> );

  const CustomConcluido = ({ row }) =>
  !row.concluidoem
    ? "-"
    : row.concluidoem.substring(8, 10) +
      "/" +
      row.concluidoem.substring(5, 7) +
      "/" +
      row.concluidoem.substring(0, 4);

  const columns = [
    {
      name: "Nome",
      selector: (row) => row.idusuario[0]?.nome,
      sortable: true
    },
    {
      name: "Treinamento",
      selector: (row) => row.titulo,
      wrap: true,
      sortable: true
    },
    {
      name: "Progresso",
      selector: row => Math.round(row.progresso) + "%",
    },
    {
      name: "Prova",
      cell: (row) => <CustomAvaliacao row={row} />,
    },
    {
      name: "Status",
      cell: (row) => <CustomStatus row={row} />,
    },
    {
      name: "Prazo",
      selector: (row) => row.dataDueDate,
      sortable: true
    },
    {
      name: 'Concluido em',
      selector: (row) => row.dataFinalizado,
    },
    {
      name: "Certificado",
      cell: (row) => <CustomCertificado row={row} />,
    },
  ];



  const [treinamentos, setTreinamentos] = useState([]);
  const [exportTreinamentos, setexportTreinamentos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [graphData, setGraphData] = useState([]);
  const [empresas, setEmpresas] = useState([]);
  const [result, setResult] = useState([]);
  const [idempresa, setIdempresa] = useState("");
  const [busca, setBusca] = useState("");
  const [buscaTreinamento, setBuscaTreinamento] = useState("");

  const userid = localStorage.getItem("sgiuserid");
  //const empresaid = localStorage.getItem("sgiempresaid");
  const isMaster = localStorage.getItem("sgimaster")

  const dataChart3 = {
    labels: ["Finalizados", "Nao Iniciados", "Em Andamento"],
    datasets: [
      {
        label: "progresso",
        data: graphData,
        backgroundColor: [
          "rgba(0, 192, 0.8)",
          'rgb(54, 162, 235)',
          'rgb(255, 205, 86)'
        ],
        //hoverOffset: 5,
      },
    ],
  };

  async function loadEmpresas() {
    if (userid === null) {
      return;
    }
    try {
      const query = "/treinamentos/empresa";
      const response = await api.get(query);
      const data = await response.data;
      setEmpresas(data);
      const empId = localStorage.getItem("sgiempresaid");
      setIdempresa(empId);
      await loadTreinamentos(empId, false, true);
    } catch (e) {
      console.error(e);
      setLoading(false);
    }
  }

  async function loadTreinamentos(idempresaFunc, clear, doResult) {
    if (userid === null || idempresaFunc === "") {
      setLoading(false);
      return;
    }
    setLoading(true);
    try {
      const query =
        "/treinamentos/produtocliente/empresa/id/empresa/" + idempresaFunc;
      const response = await api.get(query);
      const data = await response.data;

      let results = [];
      if (doResult) {
        const lookup = {};
        for (let i = 0; i < data.length; i++) {
          const item = data[i];
          const name = item.titulo;
          if (name && !(name in lookup)) {
            lookup[name] = 1;
            results.push(name);
          }
        }
      }

      const Finalizados = data.filter((item) => item.status === 1).length;
      const EmAndamento = data.filter(
        (item) => item.status === 0 && item.progresso > 0
      ).length;
      const NaoIniciados = data.filter(
        (item) => item.status === 0 && item.progresso === 0
      ).length;

      let nextTreinamentos;
      if ((busca === "" && buscaTreinamento === "") || clear === true) {
        nextTreinamentos = data.filter((item) => item.idusuario[0]?.nome);
      } else {
        nextTreinamentos = data.filter(
          (item) =>
            item.idusuario[0]?.nome &&
            item.idusuario[0].nome
              .toLowerCase()
              .includes(busca.toLowerCase()) &&
            item.titulo &&
            item.titulo.toLowerCase().includes(buscaTreinamento.toLowerCase())
        );
      }

      flushSync(() => {
        if (doResult) {
          setResult(results);
        }
        setTreinamentos(nextTreinamentos);
        setGraphData([Finalizados, NaoIniciados, EmAndamento]);
      });

      await new Promise((resolve) => {
        requestAnimationFrame(() => {
          requestAnimationFrame(() => resolve());
        });
      });
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  }

  function updateTreinamentos(selectedValue) {
    setIdempresa(selectedValue);
    loadTreinamentos(selectedValue, false, false);
    //setTreinamento("");
  }

  function efetivaBusca(clear) {
    setLoading(true);
    loadTreinamentos(idempresa,clear, false);
  }

  function downloadExcel() {
    let jsonData = {};
    let viewData = [];

    treinamentos.forEach(function(treinamento){
      if(treinamento.idusuario[0]?.nome){
       jsonData["Nome"] = treinamento.idusuario[0]?.nome;
       jsonData["Treinamento"] = treinamento.titulo;
       jsonData["Progresso"] = Math.round(treinamento.progresso) + "%";
       jsonData["Prova"] = treinamento.tentativas + " tentativa(s)";
       jsonData["Status"] = treinamento.status == 1 ? "Finalizado" : "Pendente";
       jsonData["Prazo"] = treinamento.dataDueDate;
       jsonData["Concluido em"] = treinamento.dataFinalizado;
       viewData.push(jsonData);
       jsonData = {};
      }
    });

    var wscols = [
      { width: 35 },  // first column
      { width: 65 }, // second column
      { width: 12 }, //...
      { width: 16 }, 
      { width: 13 },
      { width: 13 }, 
      { width: 13 }
    ];

    const worksheet = xlsx.utils.json_to_sheet(viewData);
    worksheet["!cols"] = wscols;   
    const workbook = xlsx.utils.book_new();
    xlsx.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    xlsx.writeFile(workbook, "Status Treinamentos.xlsx");
  };

  useEffect(() => {
    if (userid === null) window.location.href = "/login";
    loadEmpresas();
    //loadTreinamentos();    
    //loadUsuarios(localStorage.getItem("sgiempresaid"));
    setTimeout(() => {
      if (document.getElementById("menu_acompanhamento")) {
        document.getElementById("menu_acompanhamento").className = "active";
      }
    }, 50);

  }, []);

  useEffect(() => {
    if (!idempresa) {
      return;
    }
    efetivaBusca(false);
  }, [buscaTreinamento]);

  return (
    <>
      <Header />
      <SideMenu />

      <div className="content-wrapper">
        {/* Main content */}
        <section className="content">
          <div className="row">
            <div className="col-xs-12">
              <div className="box box-primary">
                <div className="box-body table-responsive">
                  <div className="admin-courses-tab">
                    <h3 className="title">Acompanhamento Progresso</h3>
                  </div>

                  
                  <div className="col-md-12" style={{marginBottom:15}}>
                  <div className="col-md-3 no-padding" style={{marginLeft:-15}}>
                        <select
                          id="idcompressor"
                          value={idempresa}
                          style={{ borderColor: "#a1a1a1", height: 50, width: 200 }}
                          placeholder="Empresa do usuário"
                          className="form-control select2"
                          disabled={isMaster == "false"}
                          onChange={(event) => updateTreinamentos(event.target.value)}
                        >
                          <option key="" value="" disabled>
                            -- Selecione --
                          </option>
                          {empresas.map((empresa) => (
                            <option key={empresa._id} value={empresa._id}>
                              {empresa.nome}
                            </option>
                          ))}
                        </select>
                        </div>

                        <div className="col-md-3 pull-right">
                        <div className="input-group">
                          <input
                            type="text"
                            name="message"
                            placeholder="Filtrar por Nome"
                            className="form-control"
                            value={busca}
                            onChange={(event) => setBusca(event.target.value)}
                            onKeyUp={(event) => {
                              if (event.key === "Enter") {
                                efetivaBusca(false);
                              }
                            }}
                          ></input>
                          <span className="input-group-btn">
                            <button type="button" className="btn btn-flat" onClick={() => {
                            efetivaBusca(false);
                          }}>
                              Filtrar
                            </button>
                          </span>
                        </div>
                        </div>
                        
                        <div className="row"> </div>
                          <div className="col-md-3 pull-right">
                          <div className="input-group">
                            <select
                              type="text"
                              name="treinamento"
                              placeholder="Filtrar por Treinamento"
                              className="form-control select2"
                              value={buscaTreinamento}
                              onChange={(event) => { 
                                setBuscaTreinamento(event.target.value);
                              }}
                            >
                              <option key="" value="" disabled>
                                -- Selecione --
                              </option>
                              {result.map((treinam) => (
                                <option key={treinam} value={treinam}>
                                  {treinam}
                                </option>
                              ))}
                            </select>
                            <span className="input-group-btn">
                              <button type="button" className="btn btn-flat" onClick={() => {
                                setBusca("");
                                setBuscaTreinamento("");
                          }}>
                                Limpar Filtros
                              </button>
                            </span>
                          </div>
                        </div>
                        <br></br>
                        <a style={{cursor:"pointer"}} onClick={()=> downloadExcel()}>
                          <i className="fa fa-cloud-download" /> Exportar Excel
                        </a>
                      </div>


                  {/* <select
                    id="idtreinamentos"
                    value={treinamento}
                    className="form-control select2"
                    style={{ borderColor: "#a1a1a1", height: 50, width: 200 }}
                    placeholder="Escolha o treinamento"
                    onChange={(event) => loadProgresso(event.target.value)}
                  >
                    <option key="" value="" disabled>
                      -- Selecione --
                    </option>
                    {treinamentos.map((item) => (
                      <option key={item._id} value={item._id}>
                        {item.titulo}
                      </option>
                    ))}
                  </select> */}
                          

                  {loading ? (
                    <LoadingSpinnerBlock
                      size={56}
                      hint="Carregando dados…"
                      padding="48px 40px"
                    />
                  ) : (
                    <div className="nav-tabs-custom">
                      <ul className="nav nav-tabs">
                        <li className="active">
                          <a
                            href="#tab_1"
                            data-toggle="tab"
                            aria-expanded="false"
                          >
                            Tabela
                          </a>
                        </li>
                        <li>
                          <a
                            href="#tab_2"
                            data-toggle="tab"
                            aria-expanded="false"
                          >
                            Grafico
                          </a>
                        </li>
                      </ul>

                      <div className="tab-content">
                        <div className="tab-pane active" id="tab_1">
                          <div className="row">
                            <div className="box-body">
                              <div className="row">
                                <div className="col-xs-12">
                                  <DataTable
                                    columns={columns}
                                    data={treinamentos}
                                    noDataComponent="Selecione o treinamento"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="tab-pane" id="tab_2">
                          <div className="row">
                            <div className="box-body">
                              <div className="row">
                                <div className="col-md-4">
                                  <Doughnut data={dataChart3} />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}


                </div>
              </div>
            </div>
          </div>

         
        </section>
        {/* /.content */}
      </div>

      <Footer />
    </>
  );
}
